// extracted by mini-css-extract-plugin
export default {"container":"artwork_container__zRelq","welcomeMessage":"artwork_welcomeMessage__2IBKk"};